export const CONTROLLER_NAME = 'PollingConfigDetailsController';
export const CREDENTIAL_TYPES = ['SNMP v2c', 'SNMP v3', 'WinRM', 'WinRM Cert', 'REST'];
export const SNMPV3_PROTOCOLS = ['None', 'HMAC-MD5', 'HMAC-SHA', 'HMAC-SHA256'];
export const SNMPV3_PRIVACY_PROTOCOLS = [
    'None',
    'AES-128',
    'AES-192',
    'AES-256',
    'AES-192-DES',
    'AES-256-DES',
    'CBC-DES',
];
export const POLLING_STATS_THRESHOLD = 80; // % based
export const MAX_INTF_SELECT_RULES = 5;

export const TAB_GENERAL = 'general';
export const TAB_IFACE_SEL = 'interfaceSelection';
export const TAB_AP_SEL = 'accessPointSelection';
export const POLLING_TABS = [TAB_GENERAL, TAB_IFACE_SEL, TAB_AP_SEL];

export const CredentialTypes = {
    'SNMP v2c': 'SNMP v2c',
    'SNMP v3': 'SNMP v3',
    WinRM: 'WinRM',
    'WinRM Cert': 'WinRM Cert',
    REST: 'API',
};

export const FIELD_MAPPINGS = {
    RATE_PER_SEC: 'rateLimitMegaBitsPerSec',
    SERVER_ENABLED: 'serverEnabled',
    SERVER_INTERVAL: 'serverInterval',
    DEVICE_ENABLED: 'deviceEnabled',
    DEVICE_INTERVAL: 'deviceInterval',
    INCLUDE_PATTERNS: 'includedPatterns',
    EXCLUDE_PATTERNS: 'excludedPatterns',
    ANY_INCLUDED: 'anyIncluded',
    LOOPBACK_EXCLUDED: 'loopbackExcluded',
    ADMINDOWN_EXCLUDED: 'adminDownExcluded',
    PATTERN_EXCLUDED: 'patternExcluded',
    PRIORITY_RULES_ALL: 'priorityRules.all',
    CRITICAL_STATUS_ENABLED: 'criticalStatusEnabled',
    PATTERNS_INCLUDED: 'patternsIncluded',
    PRIORITY_RULES_PATTERN_INCLUDED: 'priorityRules.patternsIncluded',
    PRIORITY_RULES_PATTERN: 'priorityRules.patterns',
    PRIORITY_RULES_IP_SCOPES_INCLUDED: 'priorityRules.ipScopesIncluded',
    PRIORITY_RULES_IP_SCOPES: 'priorityRules.ipScopes',
    ANY_ZONE_INCLUDED: 'anyZoneIncluded',
    INCLUDED_ZONE_PATTERNS: 'includedZonePatterns',
};

export const PollingApi = '/ngp/v2/polling-config';
export const AccessPointRulesApi = '/ngp/v2/access-point-rules';
export const InterfaceRulesApi = '/ipm/v1/admin/interfacerule';

export const FIELD_PRIORITY_RULES = {
    PATTERN: 'pattern',
    MATCH_NAME: 'matchName',
    MATCH_DESCRIPTION: 'matchDescription',
    MATCH_TYPE: 'matchType',
};

export const CRED_TABS_META = [
    {
        label: 'SNMP',
        types: ['SNMP v2c', 'SNMP v3'],
        defaultType: 'SNMP v2c',
    },
    {
        label: 'WinRM',
        types: ['WinRM', 'WinRM Cert'],
        defaultType: 'WinRM',
    },
    {
        label: 'API',
        types: ['REST'],
        defaultType: 'REST',
    },
];

export const GENERAL_DEFAULT = {
    rateLimitMegaBitsPerSec: 100,
    serverEnabled: false,
    serverInterval: 1,
    deviceEnabled: false,
    deviceInterval: 1,
    credentials: [],
};
